import { FC, ReactNode, useState } from 'react'

import { Popover, PopoverProps } from 'antd'
import styled from 'styled-components'

import { FilterButton } from './FilterButton'

export interface FilterProps {
  disabled?: boolean
  count?: number
  renderContent: (onHide: () => void) => ReactNode
}

const StyledPopover = styled((props: PopoverProps) => (
  <Popover {...props} classNames={{ root: props.className }} />
))`
  .ant-popover-inner {
    padding: 0;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.header};
  }
`
export const Filter: FC<FilterProps> = (props) => {
  const { disabled, count, renderContent } = props
  const [open, setOpen] = useState(false)
  const hide = (): void => {
    setOpen(false)
  }

  const handleOpenChange = (newOpen: boolean): void => {
    setOpen(newOpen)
  }
  const content = renderContent(hide)
  return (
    <StyledPopover
      content={content}
      trigger='click'
      placement='bottom'
      arrow={false}
      open={open}
      onOpenChange={handleOpenChange}
    >
      <FilterButton count={count} disabled={disabled} />
    </StyledPopover>
  )
}
